<template>
    <div class="flex justify-center items-center gap-2">
        <div
            v-for="step in totalSteps"
            :key="step"
            class="w-6 h-1 rounded-sm transition-colors duration-200"
            :class="{
                'bg-slate-800 dark:bg-slate-100': step <= currentStep,
                'bg-slate-200 dark:bg-slate-600': step > currentStep
            }"
        ></div>
    </div>
</template>

<script setup>
defineProps({
    currentStep: {
        type: Number,
        required: true,
        validator: (value) => value >= 1
    },
    totalSteps: {
        type: Number,
        required: true,
        validator: (value) => value >= 1
    }
});
</script>
